function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlHandLuggage = function SvgVaknlHandLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.2h-1.1c-1.2 0-2.1-1-2.1-2.1V25h2.3",
    style: {
      fill: "#fff",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 26.7c-1 0-1.8-.8-1.8-1.8s.8-1.9 1.8-1.9",
    style: {
      fill: "#3d9b8b",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.2h1.1c1.2 0 2.1-1 2.1-2.1V25h-2.3",
    style: {
      fill: "#fff",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 26.7c1 0 1.8-.8 1.8-1.8s-.8-1.9-1.8-1.9",
    style: {
      fill: "#3d9b8b",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 19.5c0 1-.8 1.8-1.8 1.8H13.3c-1 0-1.8-.8-1.8-1.8",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 28.6h15v3.3H12z",
    style: {
      fill: "#f3ad05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20v12M23 20v12M26.3 32.4H12.7c-.7 0-1.2-.5-1.2-1.2v-19c0-.7.5-1.2 1.2-1.2h13.6c.7 0 1.2.5 1.2 1.2v19c0 .6-.5 1.2-1.2 1.2zM17 10.5C17 9.1 18.1 8 19.5 8S22 9.1 22 10.5",
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 20H12.6c-1.1 0-2.1-.9-2.1-2.1V11h18v6.9c0 1.2-.9 2.1-2 2.1z",
    style: {
      fill: "#3d9b8b",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.5c0 1.1-.9 2.1-2.1 2.1H12.6c-1.1 0-2.1-.9-2.1-2.1",
    style: {
      fill: "none",
      stroke: "#288374",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 20H12.6c-1.1 0-2.1-.9-2.1-2.1V11h18v6.9c0 1.2-.9 2.1-2 2.1z",
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgVaknlHandLuggage;